export const CustomHandledErrors = [403, 401];
